export default "__VITE_ASSET__C5A4nNt0__"